<div>
    <div id="pause" class="flex align-items-center justify-content-center">
        <div id="spinner"></div>
        <!-- <div class="flex align-items-center justify-content-center" [style]="{'font-size':'1.2rem','font-weight':'bold', 'color':'white'}">Loading...</div> -->
    </div>
</div>
